import { useModelService } from 'services/model/model.service';
import { customKpi, measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';

function useCategoriesOverTimeKpis(): InfoDrawerKpiEntry[] {
  const { getMeasureByMetric } = useModelService();
  const gmvMeasure = getMeasureByMetric('ordGmvVal', 'OD');

  return [
    measureKpi(gmvMeasure),
    customKpi('shareOfTotal', {
      titleId: 'insights.measure.shareOfTotal.name',
      descriptionId: 'insights.report.share.description',
    }),
    customKpi('growth', {
      titleId: 'insights.report.growth',
      descriptionId: 'insights.report.growth.description',
    }),
    customKpi('ranking', {
      titleId: 'insights.report.ranking',
      descriptionId: 'insights.report.ranking.description',
    }),
  ];
}

export function CategoriesOverTimeReportInfoContent() {
  const kpis = useCategoriesOverTimeKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulTitleId="info.content.why_is_it_useful"
      whyUsefulDescriptionId="insights.category_tab.performance_over_time.report.why_is_it_useful"
      showOrderBasedNote
    >
      <hr className="my-4 border-snow-200" />
      <InfoContentItem
        titleId="info.content.data_availability"
        descriptionId="info.content.data_availability.description"
      />
    </InfoDrawerKpis.Default>
  );
}
